window.SMTX.ContentMenu = (function () {

  // return false;

  if ($('[data-content-menu]').length === 0) {
    return false;
  }

  Foundation.Magellan.defaults.offset = -27;

  var $menu = $('[data-content-menu] .menu');
  var index = 1;

  $('.article-body h2').each(function () {
    var $me = $(this);
    var id = 'section_0' + index;
    
    createMenuLink($me.text(), id);

    var $target = $('<div id="' + id + '" data-magellan-target="' + id + '"></div>');
    $target.css({"position": "absolute", "top" : "-240px"});
    $me.css({"position": "relative"});
    $me.prepend($target);
    

    index++;
  });

  function createMenuLink(label, id) {
    $menu.append($('<li><a href="#' + id + '">' + truncateString(label, 55) + '</a></li>'));
  }

  function truncateString(str, num) {
    if (str.length > num) {
      return str.slice(0, num) + "...";
    } else {
      return str;
    }
  }
  $('[data-content-menu] .menu a').on('click', function () {
    var elementID = $(this).attr('href');
    var pos = $(elementID).offset().top + 130; // -80 is the offset destination, normally equal to the menubar height 
    $("html, body").animate({ scrollTop: pos }, 300);
    return false;
  });


  return {

  };

})();